import { CommonModule } from '@angular/common';
import { Component, computed, Inject, input, OnInit, Signal } from '@angular/core';
import { FormsModule } from 'src/app/shared/components/forms/forms.module';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { Patient } from 'src/app/shared/models/patient';
import { Practice } from 'src/app/shared/models/practice';
import { Specialty } from 'src/app/shared/models/specialty';
import { ExperienceI18nService } from 'src/app/core/experience/experience-i18n.service';

@Component({
    selector: 'app-patient-data',
    standalone: true,
    imports: [CommonModule, FormsModule, PipesModule],
    templateUrl: './patient-data.component.html',
    styleUrl: './patient-data.component.scss'
})
export class PatientDataComponent implements OnInit {

    private experienceI18n: ExperienceI18nService = Inject(ExperienceI18nService)

    patient = input<Patient>();
    pratice = input<Practice>();
    specialty = input<string>();

    fullName: Signal<string> = computed(() => !!this.patient()?.name && !!this.patient()?.surname
        ? `${this.patient().surname}, ${this.patient().name}`
        : this.experienceI18n.translate('modules.providers.patient-data.sin-especificar', undefined, 'Sin especificar')
    );

    ngOnInit(): void {
    }
}
